import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs/Observable";
import { forkJoin, of } from 'rxjs';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { createSSEObservable } from '../../../shared/utils';
import { map, switchMap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class SagaService {
  private SERVER_URL = `${environment.API_URL}`;
  constructor(private httpClient: HttpClient, private cookieService: CookieService) { }

  public getArticolePaginate(
    vandabil = 'true', search = '', pageNumber = 0, pageSize = 200,
    sortBy = '', sortOrder = ''
  ): Observable<any> {
    const params = new HttpParams()
      .set('vandabil', vandabil)
      .set('search', search)
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder);

    return this.httpClient.get(
      this.SERVER_URL + 'company-profile/companyProfile/getArticolePaginate',
      { params }
    );
  }

   public getArticleById(id): Observable<any> {
    const params = new HttpParams()
      .set('id', id)

      return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticleById', { params });
  }

  public getArticoleSaga(vandabil = 'true', search = '', pageNumber = 0, pageSize = 10000, isSh = ''): Observable<any> {
    const params = new HttpParams()
      .set('vandabil', vandabil)
      .set('search', search)
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('isSh', isSh);

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticoleSaga', { params });
  }

  getArticoleSagaForTvaMarja(vandabil = 'true', articleId = null, search = '', pageNumber = 0, pageSize = 10000, from=null, to=null, column, order, isSh = ''): Observable<any> {
    const params = new HttpParams()
      .set('vandabil', vandabil)
      .set('articleId', articleId)
      .set('search', search)
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('isSh', isSh)
      .set('from', from ? from.valueOf().toString() : '')
      .set('to', to ? to.valueOf().toString() : '')
      .set('column', column)
      .set('order', order);

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticoleSagaForTvaMarja', { params });
  }

  public getCompanyInventory(): Observable<any> {
    const params = new HttpParams();
    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyInventory', { params });
  }

  public getRaportGestiune(gestiuneId, startTime, endTime) {
    const params = new HttpParams()
      .set('gestiuneId', gestiuneId)
      .set('startTime', startTime)
      .set('endTime', endTime)

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getRaportGestiune', { params });
  }
  
  public getRaportSituatieStocurilor(articleId, gestiuneId, startTime, endTime, intrareTypesString, iesireTypesString, page, pageSize, showFinalStocZero = true, sortBy = '', sortOrder = '') {
    const params = new HttpParams()
      .set('articleId', articleId ?? '')
      .set('gestiuneId', gestiuneId ?? '')
      .set('startTime', startTime)
      .set('intrareTypes', intrareTypesString)
      .set('iesireTypes', iesireTypesString)
      .set('endTime', endTime)
      .set('page', page)
      .set('pageSize', pageSize)
      .set('showFinalStocZero', showFinalStocZero)
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder)

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getRaportSituatieStocurilor', { params });
  }

  public getRaportSituatieStocurilorSSE(articleId, gestiuneId, startTime, endTime, intrareTypesString, iesireTypesString, page, pageSize, showFinalStocZero = true, sortBy = '', sortOrder = '', force = false) {
    const token = this.cookieService.getAll()?.clientToken;
    const params = new URLSearchParams({
      articleId: articleId ?? '',
      gestiuneId: gestiuneId ?? '',
      startTime,
      endTime,
      intrareTypes: intrareTypesString,
      iesireTypes: iesireTypesString,
      page: page.toString(),
      pageSize: pageSize.toString(),
      showFinalStocZero: showFinalStocZero.toString(),
      sortBy,
      sortOrder,
      force: force.toString()
    });
    const url = `${this.SERVER_URL}company-profile/companyProfile/getRaportSituatieStocurilorSSE?${params.toString()}`;
    
    return createSSEObservable<any>(url, {
      Authorization: `Bearer ${token}`,
      Accept: 'text/event-stream'
    });
  }

  public getAddOns(): Observable<any> {
    const params = new HttpParams()
    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getAddOns', { params });
  }

  public getArticleHistory(articleId, from='', to='', intrareTypesString, iesireTypesString, gestiuneId = null) {
    let params = new HttpParams()
        .set('articleId', articleId)
        .set('from', from)
        .set('to', to)
        .set('intrareTypes', intrareTypesString)
        .set('iesireTypes', iesireTypesString);

        if (gestiuneId !== null && gestiuneId !== undefined) {
          params = params.set('gestiuneId', String(gestiuneId));
        }    
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticleHistory', {params});
  }

  public getArticlesForGestiuneId(gestiuneId, pageSize = 10, pageNumber = 0, search = '', barcode = "", groupId = "", vandabil = false, consumabil = false): Observable<any> {
    const params = new HttpParams()
      .set('gestiuneId', gestiuneId)
      .set('search', search)
      .set('barcode', barcode)
      .set('pageSize', pageSize)
      .set('pageNumber', pageNumber)
      .set('groupId', groupId ? groupId : '')
      .set('vandabil', vandabil ? vandabil : '')
      .set('consumabil', consumabil ? consumabil : '')

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticlesForGestiuneId', { params });
  }
  
  public getArticlesForGestiuneConsumabile(gestiuneId: string | number, pageSize = 10, pageNumber = 0, search = ''): Observable<any> {
    return this.getArticlesForGestiuneId(
      gestiuneId,
      pageSize,
      pageNumber,
      search,
      "",    
      "",   
      false, 
      true   
    );
  }
  
  public getArticlesWithGestiune(pageSize = 10, pageNumber = 0, search = '', vandabil = false, onlySecondHand = false): Observable<any> {
    const params = new HttpParams()
      .set('search', search)
      .set('pageSize', pageSize)
      .set('pageNumber', pageNumber)
      .set('vandabil', vandabil ? vandabil : '')
      .set('onlySecondHand', onlySecondHand ? onlySecondHand : '');

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticlesWithGestiune', { params });
  }

  public getArticlesWithGestiuneByIds(articleGestiuneIds) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/getArticlesWithGestiuneByIds',
      {articleGestiuneIds},
      { headers });
  }


  public getArticleSaga(articleId, gestiuneId): Observable<any> {
    const params = new HttpParams()
      .set('articleId', articleId)
      .set('gestiuneId', gestiuneId)

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticleSaga', { params });
  }

  public getArticoleByIdsSaga(articleIds: number[]): Observable<any> {
    const params = new HttpParams({ fromObject: {
      'articleIds[]': articleIds.map(id => id.toString())
    }});

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticoleByIdsSaga', { params });
  }

  public getCostCenterEntries(costCenterId, from, to): Observable<any> {
    const fromUnix = from ? moment(from.getTime()).unix().toString() : null;
    const toUnix   = to ? moment(to.getTime()).unix().toString() : null;
    const params = new HttpParams()
      .set('costCenterId', costCenterId)
      .set('from', fromUnix)
      .set('to', toUnix);

    return  this.httpClient.get(this.SERVER_URL + 'cost-centers/costCenters/getCostCenterEntries', { params });
  }

  public getArticles(): Observable<any> {
    const params = new HttpParams();

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticles', { params });
  }

  public getAllArticles(): Observable<any> {
    const params = new HttpParams();

    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getAllArticles', { params });
  }

  public setBarcode(articleId: any, barcode: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/setBarcode',
      {articleId, barcode},
      { headers });
  }

  public getGestiuniSaga(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getGestiuniSaga', { params });
  }

  public getAllCompanyGestiuniSaga(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getAllCompanyGestiuniSaga', { params });
  }

  public getGestiuneById(id: any): Observable<any> {
    const params = new HttpParams()
      .set('id', id);
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getGestiuneById', { params });
  }

  public getGrupeArticoleSaga(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getGrupeArticoleSaga', { params });
  }

  public getTipArticoleSaga(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getTipArticoleSaga', { params });
  }


  public getTipArticoleMiscari(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getTipArticoleMiscari', { params });
  }

  public getPricesForArticles(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getPricesForArticles', { params });
  }

  public getLastArticleCode(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getLastArticleCode', { params });
  }

  public getLargestGestiuneAccountNumbers() {
     return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getLargestGestiuneAccountNumbers');
  }
  
  public checkBarcode(articleId, barcode) {
    const params = new HttpParams()
      .set('articleId', articleId)
      .set('barcode', barcode);

     return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/checkBarcode', { params });
  }

  generateInternalBarcode() {
    return this.httpClient.get(
      this.SERVER_URL + 'company-profile/companyProfile/generateInternalBarcode'
    );
  }

  generateInternalBarcodesForAll(): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/generateInternalBarcodesForAll',
      {},
      { headers });
  }

  generateCodesForArticlesWithoutCode(): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/generateCodesForArticlesWithoutCode',
      {},
      { headers });
  }

  public addImportedArticle(article: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addImportedArticle',
      {article},
      { headers });
  }

  public saveArticlesToGroup(articleIds, groupId, unassignArticlesByIds = []): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/saveArticlesToGroup',
      {articleIds, groupId, unassignArticlesByIds},
      { headers });
  }

  public addArticles(articles: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addArticles',
      {articles},
      { headers });
  } 

  public addGestiune(gestiune: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addGestiune',
      {gestiune},
      { headers });
  }

  public addArticleType(articleType: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addArticleType',
      {articleType},
      { headers });
  }
  
  public addStock(stock: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addStock',
      {stock},
      { headers });
  }

  public addArticle(article: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addArticle',
      {article},
      { headers });
  }

  public getArticleByCode(code: any): Observable<any> {
    const params = new HttpParams()
      .set('code', code);
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticleByCode', { params });
  }
  
  public updateArticle(article: any): Observable<any> {
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/updateArticle', {article});
  }
  
  public updateGestiune(gestiune: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/updateGestiune',
      {gestiune},
      { headers });
  }

  public updateArticleType(articleType: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/updateArticleType',
      {articleType},
      { headers });
  }

  public deleteArticle(articleId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/deleteArticle',
      {articleId},
      { headers });
  }

  public reactivateArticle(article: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/reactivateArticle',
      {article},
      { headers });
  }
  
  public transferArticle(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/transferArticle',
      {data},
      { headers });
  }
  
  public gestiuneTransfer(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/gestiuneTransfer',
      {data},
      { headers });
  }
  
  public deleteTransferDoc(transferDocId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/deleteTransferDoc',
      {transferDocId},
      { headers });
  }
  
  public devalidateTransferDoc(transferDocId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/devalidateTransferDoc',
      {transferDocId},
      { headers });
  }

  public getTransferItems(transferDocId, joined = false) {
    const params = new HttpParams()
      .set('transferDocId', transferDocId)
      .set('joined', joined ? 'true' : '')

     return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getTransferItems', { params });
  }

  public getCompanyTransfersCountBySeries(series) {
    const params = new HttpParams()
      .set('series', series);
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyTransfersCountBySeries', {params});
  }
  
  public checkAccountAvailabilityForGestiune(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/checkAccountAvailabilityForGestiune',
      {data},
      { headers });
  }

  public getArticleTypeByArticleIdAndGestiuneId(articleId, gestiuneId) {
    const params = new HttpParams()
      .set('articleId', articleId)
      .set('gestiuneId', gestiuneId);

     return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticleTypeByArticleIdAndGestiuneId', { params });
  }

  public getInitialStocForArticleIdAndGestiuneId(articleId, gestiuneId) {
    const params = new HttpParams()
      .set('articleId', articleId)
      .set('gestiuneId', gestiuneId);

     return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getInitialStocForArticleIdAndGestiuneId', { params });
  }

  public getSgrData(from, to, gestiuneId): Observable<any> {
    const fromUnix = from ? moment(from.getTime()).startOf('day').unix() : null;
    const toUnix   = to ? moment(to.getTime()).endOf('day').unix() : null;

    const params = new HttpParams()
      .set('from', fromUnix)
      .set('to', toUnix)
      .set('gestiuneId', gestiuneId)

    return this.httpClient.get(this.SERVER_URL + 'company-invoices/companyInvoices/getSgrData', { params });
  }

  getIntrariForArticle(gestiuneId, articleId, quantity) {
    const params = new HttpParams()
      .set('gestiuneId', gestiuneId)
      .set('articleId', articleId)
      .set('quantity', quantity)

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getIntrariForArticle', { params });
  }
  
  getIntrariForArticleQtyPairs(gestiuneId, articleQtyPairs, bonConsumId = null, avizId = null) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/getIntrariForArticleQtyPairs',
      {gestiuneId, articleQtyPairs, bonConsumId, avizId},
      { headers });
  }

  setMinimumStock(articleId, gestiuneId, minimumStock) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/setMinimumStock',
      {articleId, gestiuneId, minimumStock},
      { headers });
  }

  getMinimumStock(articleId, gestiuneId) {
    const params = new HttpParams()
      .set('articleId', articleId ?? '')
      .set('gestiuneId', gestiuneId ?? '')
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getMinimumStock', { params });
  }

  checkMinimumStockForInvoiceItems(items) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/checkMinimumStockForInvoiceItems',
      {items},
      { headers });
  }

  getStockForArticleInGestiune(articleId, gestiuneId) {
    const params = new HttpParams()
      .set('articleId', articleId)
      .set('gestiuneId', gestiuneId)
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getStockForArticleInGestiune', { params });
  }

  getArticleLocationsByArticleAndGestiune(articleId, gestiuneId) {
    const params = new HttpParams()
      .set('articleId', articleId)
      .set('gestiuneId', gestiuneId)
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getArticleLocationsByArticleAndGestiune', { params });
  }

  syncArticleLocations(articleId: number, gestiuneId: number, locationIds: number[]) {

    return this.httpClient.post(
      this.SERVER_URL + 'company-profile/companyProfile/syncArticleLocations',
      { articleId, gestiuneId, locationIds }
    );
  }

  public resetAnafFetchData(): Observable<any> {
    return this.httpClient.post(this.SERVER_URL+ 'company-profile/companyProfile/resetAnafFetchData', {});

  }

  getConturi(): Observable<any> {
    const params = new HttpParams();
    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getConturi', { params });
  }

  getCompanyPlanConturi(): Observable<any> {
    const params = new HttpParams();
    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyPlanConturi', { params });
  }

  getCompanyPlanConturiAnalitice(): Observable<any> {
    const params = new HttpParams();
    return  this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyPlanConturiAnalitice', { params });
  }

  getCompanyPlanConturiCombined(): Observable<any> {
    return forkJoin({
      sintetice: this.getCompanyPlanConturi(),
      analitice: this.getCompanyPlanConturiAnalitice(),
    }).pipe(
      map(({ sintetice, analitice }) => {
        const sinteticeRaw: any[] = Array.isArray(sintetice) ? sintetice : (sintetice?.data ?? []);
        const analiticeRaw:  any[] = Array.isArray(analitice) ? analitice : (analitice?.data ?? []);

        const itemsByValue = new Map();

        for (const s of sinteticeRaw) {
          const item = {
            id: s.idContSintetic,
            rawName: String(s.denumire ?? '').trim(),
            name: `${String(s.denumire ?? '').trim()} (cont: ${s.cont ?? ''})`,
            value: `sintetic:${String(s.idContSintetic)}`,
            label: `${String(s.denumire ?? '').trim()} (cont: ${s.cont ?? ''})`,
            type: 'sintetic',
          };
          itemsByValue.set(item.value, item);
        }

        for (const a of analiticeRaw) {
          const item = {
            id: a.id,
            rawName: String(a.denumire ?? '').trim(),
            name:  `${String(a.denumire ?? '').trim()} (cont: ${a.contAnalitic ?? ''})`,
            value: `analitic:${String(a.id)}`,
            label: `${String(a.denumire ?? '').trim()} (cont: ${a.contAnalitic ?? ''})`,
            type: 'analitic',
          };
          itemsByValue.set(item.value, item);
        }

        return Array.from(itemsByValue.values());
      })
    );
  }

  addCompanyPlanConturi(idContSintetic): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addCompanyPlanConturi',
      {idContSintetic},
      { headers });
  }

  addCompanyPlanConturiAnalitice(idContSintetic, denumire, contAnalitic): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addCompanyPlanConturiAnalitice',
      {idContSintetic, denumire, contAnalitic},
      { headers });
  }

  editCompanyPlanConturiAnalitice(idContAnalitic, denumire, contAnalitic): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/editCompanyPlanConturiAnalitice',
      {idContAnalitic, denumire, contAnalitic},
      { headers });
  }

  removeCompanyPlanConturiAnalitice(idContAnalitic): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/removeCompanyPlanConturiAnalitice',
      {idContAnalitic},
      { headers });
  }

  removeCompanyPlanConturi(idContSintetic): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/removeCompanyPlanConturi',
      {idContSintetic},
      { headers });
  }

  public getArticleRecipe(articleId: any): Observable<any> {
    const params = new HttpParams().set('articleId', articleId);

    return this.httpClient.get(
      this.SERVER_URL + 'company-profile/companyProfile/getArticleRecipe',
      { params }
    );
  }

  public saveArticleRecipe(payload: any): Observable<any> {
    return this.httpClient.post(
      this.SERVER_URL + 'company-profile/companyProfile/saveArticleRecipe',
      payload
    );
  }

  getTransfers(paramData) {
    const params = new HttpParams().appendAll(paramData);
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getTransfers', {params});
  }

  getLastMiscareIntrareForArticle(articleId) {
    const params = new HttpParams().set('articleId', articleId);

    return this.httpClient.get(
      this.SERVER_URL + 'company-profile/companyProfile/getLastMiscareIntrareForArticle',
      { params }
    );
  }

  getAvailableIncomingMovements(articleId): Observable<any> {
    const params = new HttpParams()
      .set('articleId', articleId);
    return this.httpClient.get(
      this.SERVER_URL + 'company-profile/companyProfile/getAvailableIncomingMovements',
      { params }
    );
  }

  public updateNonGestiunePrice(payload: { articleId: number; price: number; vat: number; priceWithVat: number }): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/updateNonGestiunePrice',
      payload,
      { headers });
  }

  public getNonGestiuneCurrentPrice(articleId: number): Observable<any> {
    const params = new HttpParams().set('articleId', String(articleId));
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getNonGestiuneCurrentPrice', { params });
  }

  public getNonGestiuneArticles(search = '', pageNumber = 0, pageSize = 100000, groupId = ''): Observable<any> {
    const params = new HttpParams()
      .set('search', search)
      .set('pageNumber', String(pageNumber))
      .set('pageSize', String(pageSize))
      .set('onlyVandabil', 'false')
      .set('groupId', groupId);
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getNonGestiuneArticles', { params });
  }

  public checkIfArticleUsedInDocuments(articleId: number | string): Observable<any> {
    const params = new HttpParams().set('articleId', String(articleId));
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/checkIfArticleUsedInDocuments', { params });
  }
 
  public getAllGestiuni(): Observable<any> {
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getAllCompanyGestiuniSaga');
  }
  getArticleByBarcode(gestiuneId: string, barcode: string): Observable<any> {
    const params = new HttpParams()
      .set('gestiuneId', gestiuneId)
      .set('barcode', barcode);
    return this.httpClient.get(this.SERVER_URL + 'company-pos/CompanyPos/getArticleByBarcode', { params });
  }
}